import { captureException } from '@sentry/browser'
import * as apis from 'libs/apis/helper'
import * as firebase from 'libs/firebase'

const registerToken = async (fcmToken: string): Promise<void> => {
  try {
    await apis.fetchAPI({
      apiUrl: window._env_.REACT_APP_API_URL,
      method: 'POST',
      path: `/v1/push-notification/fcm`,
      options: { data: { fcmToken, os: 'website' } },
    })
  } catch (error) {
    captureException(error)
  }
}

export const registerNotificationToken = async (): Promise<void> => {
  const fcmToken = await firebase.getRegisterToken()

  if (!fcmToken) {
    console.warn('[registerNotificationToken] skipped empty token')

    return
  }

  await registerToken(fcmToken)
}
